import React from 'react';

import StageFormContentGroup from '../StageFormContentGroup/StageFormContentGroup';

export const EMPTY_VALUE_MESSAGE = 'No answer provided';

const QuestionnaireViewOnlyContent = ({ questionnaire }) => {
    if (!questionnaire?.length)
        return (
            <p className="font-body text-body-regular-m text-neutral-300 italic">
                No questionnaire provided
            </p>
        );

    return (
        <div className="flex flex-col gap-8 lg:gap-[40px]">
            {questionnaire.map((group) => {
                const { label, name } = group;

                return (
                    <div key={name} className="flex flex-col gap-6">
                        <p className="font-heading-bold text-heading-bold-m text-neutral-500">
                            {label}
                        </p>

                        <StageFormContentGroup group={group} isViewOnly />
                    </div>
                );
            })}
        </div>
    );
};

export default QuestionnaireViewOnlyContent;
